// extracted by mini-css-extract-plugin
export default {"videoCard":"UniversityVideos_videoCard__1ATMg"};